// Wed Oct 10 18:24:27 2018
import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import "./../../assests/styles/SideMenu.css";

export default class sideMenu extends Component {

	componentDidMount() {
		var sidebar = document.getElementById("sidebar");
		if (sidebar) {
			var headerHeight = document.getElementById("header").offsetHeight;
			sidebar.style.height = (window.innerHeight - headerHeight) + 'px';
		}
	}
	render() {
		return (
			<div className="sidebar" id="sidebar">
				<NavLink className="" to={"/CreditLines"}>
					Credit Lines
				</NavLink>
				<NavLink className="" to={"/CreditTransactions"}>
					Credit Transaction
				</NavLink>
				<NavLink className="" to={"/createCreditLine"}>
					Activate Credit
				</NavLink>
				<NavLink className="" to={"/CreditAnchor"}>
					Credit Anchor
				</NavLink>
				<NavLink className="" to={"/customerCreditDetails"}>
					Customer Credit Details
				</NavLink>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/common/sideMenu/sideMenu.js